import { Outlet, useLocation, Link } from "react-router-dom"
import { User, CreditCard, MicrophoneSpeaking, Settings } from "iconoir-react"
import { useEffect, useContext } from "react"
import { UserContext } from "@/components/dashboard/contexts"

const SettingsLayout = () => {
  const location = useLocation()
  const user = useContext(UserContext)

  const subNav = [
    {
      name: "Profile",
      href: "/settings/profile",
      icon: User
    },
    {
      name: "Billing",
      href: "/settings/plan",
      icon: CreditCard,
      show: user.show_billing_nav == true && user.plan != "freemium"
    },
    {
      name: "AI",
      href: "/settings/voice",
      icon: MicrophoneSpeaking
    }
  ]

  useEffect(() => {
    document.title = "Vibrato - Settings"
  }, [])

  return (
    <div className="h-full w-full flex flex-col">
      <div className="p-6 md:p-8">
        <div className="flex items-center gap-4 mb-8">
          <div className="p-3 bg-purple-100 rounded-xl">
            <Settings width="28" height="28" className="text-purple-600" />
          </div>
          <div>
            <h1 className="text-3xl font-bold text-gray-900">Settings</h1>
            <p className="text-gray-600">Manage your account and preferences</p>
          </div>
        </div>

        <div className="border-b border-gray-200">
          <nav className="-mb-px flex flex-wrap gap-x-4 gap-y-2 md:gap-x-6" aria-label="Tabs">
            {subNav
              .filter((item) => item.show !== false)
              .map((item) => (
                <Link
                  key={item.name}
                  to={item.href}
                  className={`flex items-center gap-2 whitespace-nowrap border-b-2 py-3 px-1 text-sm font-medium transition-colors ${
                    location.pathname === item.href
                      ? "border-purple-600 text-purple-600"
                      : "border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700"
                  }`}
                >
                  <item.icon
                    className={`w-5 h-5 ${location.pathname === item.href ? "text-purple-600" : "text-gray-400"}`}
                  />
                  {item.name}
                </Link>
              ))}
          </nav>
        </div>
      </div>
      <div className="flex-grow p-6 md:p-8 md:pt-0">
        <Outlet />
      </div>
    </div>
  )
}

export default SettingsLayout
